
import React, { useMemo } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { DataTable } from 'primereact/datatable';
import { countryList } from "../../components/Conteries";
import { Column } from 'primereact/column';
import Config from "../../Config.js";
import 'primeflex/primeflex.css';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';

export const BestScancategoryisall = ({ isOpen, toggleCetegoryTableclosed, DatatableCategoryList, togglecategory }) => {
    const buttonTemplate = (data) => (
        <>
            <div>
                <button
                    onClick={() => {
                        togglecategory(data);
                    }}
                    className="btn btn-primary btn-xs ml-3 "
                >
                    Details
                </button >
            </div>
        </>
    );
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggleCetegoryTableclosed}
            className="modal-size"
        >
            <ModalHeader
                toggle={toggleCetegoryTableclosed}
                className="modalheader "
            >
                <div className="widget-list-item">
                    <h4 className="widget-list-action text-nowrap text-white pb-1 pt-1 text-left">
                        Category wise scanning
                    </h4>
                </div>
            </ModalHeader>
            <ModalBody>



                <div className="sparkline8-list shadow-reset">
                    <div className="sparkline8-graph table-responsive">
                        <DataTable
                            value={DatatableCategoryList}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[10, 20, 30, 50]}
                            tableStyle={{ minWidth: '45rem' }}
                            totalRecords={DatatableCategoryList ? DatatableCategoryList?.length : 0}
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                            className="justify-content-end"
                            stripedRows
                            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
                            <Column
                                field="sr"
                                header="Sr #"
                                style={{
                                    width: '7%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 10px',
                                    textAlign: 'center',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="categoryName"
                                header="Category"
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                    fontWeight: "600"

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="totalBestScanCount"
                                header="Total Scans"
                                sortable
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="representative.name"
                                header="Actions"
                                style={{
                                    width: '2%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                body={buttonTemplate}
                            />
                        </DataTable>


                    </div>
                </div>

            </ModalBody>
        </Modal>
    );
};

export const Bestscancountryishowall = ({ isOpen, togglecountryTableclosed, DatatablecountryWiseScanLits, toggleCountry }) => {
    const buttonTemplate = (data) => (
        <>
            <div>
                <button
                    onClick={() => {
                        toggleCountry(data);
                    }}
                    className="btn btn-primary btn-xs ml-3 "
                >
                    Details
                </button >
            </div>
        </>
    );

    const countryBodyTemplate = (rowData) => {
        let CountryId = countryList.find((x) => x.name === rowData.name);
        return (
            <div className="flex widget-list-media icon w-100" style={{ textAlign: 'center' }}>
                <img
                    src={`https://flagpedia.net/data/flags/normal/${CountryId?.code?.toLowerCase()}.png`}
                    className="flag-image-left"
                />
                <div className="widget-list-content  pb-1 pt-1 border-none d-inline-block">
                    <h5 className="widget-list-title">{rowData.name}</h5>
                    {/* <span>{rowData.name}</span> */}

                </div>
            </div>
            // <div className="flex align-items-center gap-2">
            //     <img alt={CountryId.code?.toLowerCase()} src="https://primefaces.org/cdn/primereact/images/flag/flag_placeholder.png" className={`flag flag-${CountryId.code?.toLowerCase()}`} style={{ width: '24px' }} />
            //     <span>{rowData.name}</span>
            // </div>
        );
    };
    return (
        <Modal
            isOpen={isOpen}
            toggle={togglecountryTableclosed}
            className="modal-size"
        >
            <ModalHeader
                toggle={togglecountryTableclosed}
                className="modalheader "
            >
                <div className="widget-list-item">
                    <h4 className="widget-list-action text-nowrap text-white pb-1 pt-1 text-left">
                        Country wise scans
                    </h4>
                </div>
            </ModalHeader>
            <ModalBody>
                <div className="sparkline8-list shadow-reset">
                    <div className="sparkline8-graph table-responsive">
                        <DataTable
                            value={DatatablecountryWiseScanLits}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[10, 20, 30, 50]}
                            tableStyle={{ minWidth: '45rem' }}
                            totalRecords={DatatablecountryWiseScanLits ? DatatablecountryWiseScanLits?.length : 0}
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                            className="justify-content-end"
                            stripedRows
                            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
                            <Column
                                field="sr"
                                header="Sr #"
                                style={{
                                    width: '7%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 10px',
                                    textAlign: 'center',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="name"
                                header="Country"
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                    fontWeight: "600"

                                }}
                                body={countryBodyTemplate}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="totalScanCount"
                                header="Total Scans"
                                sortable
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="representative.name"
                                header="Actions"
                                style={{
                                    width: '2%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                body={buttonTemplate}
                            />
                        </DataTable>


                    </div>
                </div>

            </ModalBody>
        </Modal>
    );
};

export const BestScanWiseishowall = ({ isOpen, toggleclosedBestscanned, DatatableBestScanList, gotoreportsAttribute }) => {
    const buttonTemplate = (data) => (
        <>
            <div>
                <button
                    onClick={() => {
                        gotoreportsAttribute(data);
                    }}
                    className="btn btn-primary btn-xs ml-3 "
                >
                    Details
                </button >
            </div>
        </>
    );

    const productImageBodyTemplate = (rowData) => {

        let FullPath = `${Config.contentUrl + rowData.imagePath}`;
        return (
            <img
                src={FullPath}
                style={{ height: "50px" }}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = "../assets/img/noimage.jpg";
                    //currentTarget.src = "../assets/img/mtsttqr.png";
                }}
            ></img>

        );

    };
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggleclosedBestscanned}
            className="modal-size"
        >
            <ModalHeader
                toggle={toggleclosedBestscanned}
                className="modalheader "
            >
                <div className="widget-list-item">
                    <h4 className="widget-list-action text-nowrap text-white pb-1 pt-1 text-left">
                        Best scanned
                    </h4>
                </div>
            </ModalHeader>
            <ModalBody>
                <div className="sparkline8-list shadow-reset">
                    <div className="sparkline8-graph table-responsive">
                        <DataTable
                            value={DatatableBestScanList}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[10, 20, 30, 50]}
                            tableStyle={{ minWidth: '45rem' }}
                            totalRecords={DatatableBestScanList ? DatatableBestScanList?.length : 0}
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                            className="justify-content-end"
                            stripedRows
                            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
                            <Column
                                field="sr"
                                header="Sr #"
                                style={{
                                    width: '7%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 10px',
                                    textAlign: 'center',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="productName"
                                header="Name"
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                    fontWeight: "600"

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />

                            <Column
                                field="productName"
                                header="Pic"
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                    fontWeight: "600"

                                }}
                                body={productImageBodyTemplate}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="totalBestScanCount"
                                header="Total Scans"
                                sortable
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            {/* <Column
                                field="representative.name"
                                header="Actions"
                                style={{
                                    width: '2%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                body={buttonTemplate}
                            /> */}
                        </DataTable>


                    </div>
                </div>

            </ModalBody>
        </Modal>
    );
};

export const BestScanWalletisall = ({ isOpen, toggleclosedWalletBestscanned, DatatableBestScanWalletList, gotoreportsAttribute }) => {
    const buttonTemplate = (data) => (
        <>
            <div>
                <button
                    onClick={() => {
                        gotoreportsAttribute(data);
                    }}
                    className="btn btn-primary btn-xs ml-3 "
                >
                    Details
                </button >
            </div>
        </>
    );



    const productImageBodyTemplate = (rowData) => {

        let FullPath = `${Config.contentUrl + rowData.imagePath}`;
        return (
            <img
                src={FullPath}
                style={{ height: "50px" }}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = "../assets/img/noimage.jpg";
                    //currentTarget.src = "../assets/img/mtsttqr.png";
                }}
            ></img>

        );

    };
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggleclosedWalletBestscanned}
            className="modal-size"
        >
            <ModalHeader
                toggle={toggleclosedWalletBestscanned}
                className="modalheader "
            >
                <div className="widget-list-item">
                    <h4 className="widget-list-action text-nowrap text-white pb-1 pt-1 text-left">
                        Best scanned
                    </h4>
                </div>
            </ModalHeader>
            <ModalBody>
                <div className="sparkline8-list shadow-reset">
                    <div className="sparkline8-graph table-responsive">
                        <DataTable
                            value={DatatableBestScanWalletList}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[10, 20, 30, 50]}
                            tableStyle={{ minWidth: '45rem' }}
                            totalRecords={DatatableBestScanWalletList ? DatatableBestScanWalletList?.length : 0}
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                            className="justify-content-end"
                            stripedRows
                            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
                            <Column
                                field="sr"
                                header="Sr #"
                                style={{
                                    width: '7%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 10px',
                                    textAlign: 'center',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="productName"
                                header="Name"
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                    fontWeight: "600"

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />

                            <Column
                                field="Image"
                                header="Pic"
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                    fontWeight: "600"

                                }}
                                body={productImageBodyTemplate}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="totalBestScanCount"
                                header="Total Saved"
                                sortable
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="representative.name"
                                header="Actions"
                                style={{
                                    width: '2%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                body={buttonTemplate}
                            />
                        </DataTable>


                    </div>
                </div>

            </ModalBody>
        </Modal>
    );
};


export const BestScanVendorisall = ({ isOpen, toggleVendorsshowall, DatatableVendorWiseList, getVendorwisescanningDetail }) => {
    const buttonTemplate = (data) => (
        <>
            <div>
                <button
                    onClick={() => {
                        getVendorwisescanningDetail(data);
                    }}
                    className="btn btn-primary btn-xs ml-3 "
                >
                    Details
                </button >
            </div>
        </>
    );



    const productImageBodyTemplate = (rowData) => {

        let FullPath = `${Config.contentUrl + rowData.logoPath}`;
        return (
            <img
                src={FullPath}
                style={{ height: "50px" }}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = "../assets/img/noimage.jpg";
                }}
            ></img>

        );

    };
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggleVendorsshowall}
            className="modal-size"
        >
            <ModalHeader
                toggle={toggleVendorsshowall}
                className="modalheader "
            >
                <div className="widget-list-item">
                    <h4 className="widget-list-action text-nowrap text-white pb-1 pt-1 text-left">
                        Best performing vendors
                    </h4>
                </div>
            </ModalHeader>
            <ModalBody>
                <div className="sparkline8-list shadow-reset">
                    <div className="sparkline8-graph table-responsive">
                        <DataTable
                            value={DatatableVendorWiseList}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[10, 20, 30, 50]}
                            tableStyle={{ minWidth: '45rem' }}
                            totalRecords={DatatableVendorWiseList ? DatatableVendorWiseList?.length : 0}
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                            className="justify-content-end"
                            stripedRows
                            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
                            <Column
                                field="sr"
                                header="Sr #"
                                style={{
                                    width: '7%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 10px',
                                    textAlign: 'center',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="vendorName"
                                header="Vendor Name"
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                    fontWeight: "600"

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />

                            <Column
                                field="Image"
                                header="Logo"
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                    fontWeight: "600"

                                }}
                                body={productImageBodyTemplate}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="totalVendorScanCount"
                                header="Total Scans"
                                sortable
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="representative.name"
                                header="Actions"
                                style={{
                                    width: '2%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                body={buttonTemplate}
                            />
                        </DataTable>


                    </div>
                </div>

            </ModalBody>
        </Modal>
    );
};

export const Bestperforminglabel = ({ isOpen, toggleLableTableclosed, DatatableLebalList, toggleLabel }) => {
    const buttonTemplate = (data) => (
        <>
            <div>
                <button
                    onClick={() => {
                        toggleLabel(data);
                    }}
                    className="btn btn-primary btn-xs ml-3 "
                >
                    Details
                </button >
            </div>
        </>
    );



    const productImageBodyTemplate = (rowData) => {

        let FullPath = `${Config.contentUrl + rowData.logoPath}`;
        return (
            <img
                src={FullPath}
                style={{ height: "50px" }}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = "../assets/img/noimage.jpg";
                }}
            ></img>

        );

    };
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggleLableTableclosed}
            className="modal-size"
        >
            <ModalHeader
                toggle={toggleLableTableclosed}
                className="modalheader "
            >
                <div className="widget-list-item">
                    <h4 className="widget-list-action text-nowrap text-white pb-1 pt-1 text-left">
                        Best performing label
                    </h4>
                </div>
            </ModalHeader>
            <ModalBody>
                <div className="sparkline8-list shadow-reset">
                    <div className="sparkline8-graph table-responsive">
                        <DataTable
                            value={DatatableLebalList}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[10, 20, 30, 50]}
                            tableStyle={{ minWidth: '45rem' }}
                            totalRecords={DatatableLebalList ? DatatableLebalList?.length : 0}
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                            className="justify-content-end"
                            stripedRows
                            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
                            <Column
                                field="sr"
                                header="Sr #"
                                style={{
                                    width: '7%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 10px',
                                    textAlign: 'center',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="labelName"
                                header="Lable"
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                    fontWeight: "600"

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />

                            <Column
                                field="Image"
                                header="Logo"
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                    fontWeight: "600"

                                }}
                                body={productImageBodyTemplate}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="totalVendorScanCount"
                                header="Total Scans"
                                sortable
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="representative.name"
                                header="Actions"
                                style={{
                                    width: '2%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                body={buttonTemplate}
                            />
                        </DataTable>


                    </div>
                </div>

            </ModalBody>
        </Modal>
    );
};


//Article reports

export const TimeWiseAnalysis = ({ isOpen, toggleLableTableclosed, articleTimeWiseScanListDetalis }) => {

    const productImageBodyTemplate = (rowData) => {

        let FullPath = `${Config.contentUrl + rowData.imagePath}`;
        return (
            <img
                src={FullPath}
                style={{ height: "50px" }}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = "../assets/img/noimage.jpg";
                }}
            ></img>

        );

    };
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggleLableTableclosed}
            className="modal-size"
        >
            <ModalHeader
                toggle={toggleLableTableclosed}
                className="modalheader "
            >
                <div className="widget-list-item">
                    <h4 className="widget-list-action text-nowrap text-white pb-1 pt-1 text-left">
                        Time Wise Analysis
                    </h4>
                </div>
            </ModalHeader>
            <ModalBody>
                <div className="sparkline8-list shadow-reset">
                    <div className="sparkline8-graph table-responsive">
                        <DataTable
                            value={articleTimeWiseScanListDetalis}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[10, 20, 30, 50]}
                            tableStyle={{ minWidth: '45rem' }}
                            totalRecords={articleTimeWiseScanListDetalis ? articleTimeWiseScanListDetalis?.length : 0}
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                            className="justify-content-end"
                            stripedRows
                            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
                            <Column
                                field="sr"
                                header="Sr #"
                                style={{
                                    width: '7%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 10px',
                                    textAlign: 'center',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="articleName"
                                header="Articale name"
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                    fontWeight: "600"

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />

                            <Column
                                field="Image"
                                header="Image"
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                    fontWeight: "600"

                                }}
                                body={productImageBodyTemplate}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="totalScanCount"
                                header="Total Scans"
                                sortable
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                        </DataTable>


                    </div>
                </div>

            </ModalBody>
        </Modal>
    );
};

export const Countrywisescans = ({ isOpen, togglecountryTableclosed, DatatablecountryWiseScanLits, getCountrywisescanningDetail }) => {

    const buttonTemplate = (data) => (
        <>
            <div>
                <button
                    onClick={() => {
                        getCountrywisescanningDetail(data);
                    }}
                    className="btn btn-primary btn-xs ml-3 "
                >
                    Details
                </button >
            </div>
        </>
    );

    const countryBodyTemplate = (rowData) => {
        let CountryId = countryList.find((x) => x.name === rowData.name);
        return (
            <div className="flex widget-list-media icon w-100" style={{ textAlign: 'center' }}>
                <img
                    src={`https://flagpedia.net/data/flags/normal/${CountryId?.code?.toLowerCase()}.png`}
                    className="flag-image-left"
                />
                <div className="widget-list-content  pb-1 pt-1 border-none d-inline-block">
                    <h5 className="widget-list-title">{rowData.name}</h5>


                </div>
            </div>

        );
    };
    return (
        <Modal
            isOpen={isOpen}
            toggle={togglecountryTableclosed}
            className="modal-size"
        >
            <ModalHeader
                toggle={togglecountryTableclosed}
                className="modalheader "
            >
                <div className="widget-list-item">
                    <h4 className="widget-list-action text-nowrap text-white pb-1 pt-1 text-left">
                        Country wise scans
                    </h4>
                </div>
            </ModalHeader>
            <ModalBody>
                <div className="sparkline8-list shadow-reset">
                    <div className="sparkline8-graph table-responsive">
                        <DataTable
                            value={DatatablecountryWiseScanLits}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[10, 20, 30, 50]}
                            tableStyle={{ minWidth: '45rem' }}
                            totalRecords={DatatablecountryWiseScanLits ? DatatablecountryWiseScanLits?.length : 0}
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                            className="justify-content-end"
                            stripedRows
                            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
                            <Column
                                field="sr"
                                header="Sr #"
                                style={{
                                    width: '7%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 10px',
                                    textAlign: 'center',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="name"
                                header="Country"
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                    fontWeight: "600"

                                }}
                                body={countryBodyTemplate}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="totalScanCount"
                                header="Total Scans"
                                sortable
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="representative.name"
                                header="Actions"
                                style={{
                                    width: '2%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                body={buttonTemplate}
                            />
                        </DataTable>


                    </div>
                </div>

            </ModalBody>
        </Modal>
    );
};

export const Articleperforminglabel = ({ isOpen, toggleLableTableclosed, DatatableLebalList, getLablewisescanningDetail }) => {
    const buttonTemplate = (data) => (
        <>
            <div>
                <button
                    onClick={() => {
                        getLablewisescanningDetail(data);
                    }}
                    className="btn btn-primary btn-xs ml-3 "
                >
                    Details
                </button >
            </div>
        </>
    );



    const productImageBodyTemplate = (rowData) => {

        let FullPath = `${Config.contentUrl + rowData.logoPath}`;
        return (
            <img
                src={FullPath}
                style={{ height: "50px" }}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = "../assets/img/noimage.jpg";
                }}
            ></img>

        );

    };
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggleLableTableclosed}
            className="modal-size"
        >
            <ModalHeader
                toggle={toggleLableTableclosed}
                className="modalheader "
            >
                <div className="widget-list-item">
                    <h4 className="widget-list-action text-nowrap text-white pb-1 pt-1 text-left">
                    Best performing label
                    </h4>
                </div>
            </ModalHeader>
            <ModalBody>
                <div className="sparkline8-list shadow-reset">
                    <div className="sparkline8-graph table-responsive">
                        <DataTable
                            value={DatatableLebalList}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[10, 20, 30, 50]}
                            tableStyle={{ minWidth: '45rem' }}
                            totalRecords={DatatableLebalList ? DatatableLebalList?.length : 0}
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                            className="justify-content-end"
                            stripedRows
                            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
                            <Column
                                field="sr"
                                header="Sr #"
                                style={{
                                    width: '7%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 10px',
                                    textAlign: 'center',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="labelName"
                                header="Lable"
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                    fontWeight: "600"

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />

                            <Column
                                field="Image"
                                header="Logo"
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                    fontWeight: "600"

                                }}
                                body={productImageBodyTemplate}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="totalVendorScanCount"
                                header="Total Scans"
                                sortable
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="representative.name"
                                header="Actions"
                                style={{
                                    width: '2%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                body={buttonTemplate}
                            />
                        </DataTable>


                    </div>
                </div>

            </ModalBody>
        </Modal>
    );
};


//Production reports

export const ProductionTimeWiseAnalysis = ({ isOpen, toggleLableTableclosed, articleTimeWiseScanListDetalis }) => {

    const productImageBodyTemplate = (rowData) => {

        let FullPath = `${Config.contentUrl + rowData.imagePath}`;
        return (
            <img
                src={FullPath}
                style={{ height: "50px" }}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = "../assets/img/noimage.jpg";
                }}
            ></img>

        );

    };
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggleLableTableclosed}
            className="modal-size"
        >
            <ModalHeader
                toggle={toggleLableTableclosed}
                className="modalheader "
            >
                <div className="widget-list-item">
                    <h4 className="widget-list-action text-nowrap text-white pb-1 pt-1 text-left">
                        Time Wise Analysis
                    </h4>
                </div>
            </ModalHeader>
            <ModalBody>
                <div className="sparkline8-list shadow-reset">
                    <div className="sparkline8-graph table-responsive">
                        <DataTable
                            value={articleTimeWiseScanListDetalis}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[10, 20, 30, 50]}
                            tableStyle={{ minWidth: '45rem' }}
                            totalRecords={articleTimeWiseScanListDetalis ? articleTimeWiseScanListDetalis?.length : 0}
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                            className="justify-content-end"
                            stripedRows
                            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
                            <Column
                                field="sr"
                                header="Sr #"
                                style={{
                                    width: '7%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 10px',
                                    textAlign: 'center',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="articleName"
                                header="Articale name"
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                    fontWeight: "600"

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />

                            <Column
                                field="Image"
                                header="Image"
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                    fontWeight: "600"

                                }}
                                body={productImageBodyTemplate}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="totalScanCount"
                                header="Total Scans"
                                sortable
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                        </DataTable>


                    </div>
                </div>

            </ModalBody>
        </Modal>
    );
};

export const ProductionCountrywisescans = ({ isOpen, togglecountryTableclosed, DatatablecountryWiseScanLits, toggleCountry }) => {

    const buttonTemplate = (data) => (
        <>
            <div>
                <button
                    onClick={() => {
                        toggleCountry(data);
                    }}
                    className="btn btn-primary btn-xs ml-3 "
                >
                    Details
                </button >
            </div>
        </>
    );

    const countryBodyTemplate = (rowData) => {
        let CountryId = countryList.find((x) => x.name === rowData.name);
        return (
            <div className="flex widget-list-media icon w-100" style={{ textAlign: 'center' }}>
                <img
                    src={`https://flagpedia.net/data/flags/normal/${CountryId?.code?.toLowerCase()}.png`}
                    className="flag-image-left"
                />
                <div className="widget-list-content  pb-1 pt-1 border-none d-inline-block">
                    <h5 className="widget-list-title">{rowData.name}</h5>


                </div>
            </div>

        );
    };
    return (
        <Modal
            isOpen={isOpen}
            toggle={togglecountryTableclosed}
            className="modal-size"
        >
            <ModalHeader
                toggle={togglecountryTableclosed}
                className="modalheader "
            >
                <div className="widget-list-item">
                    <h4 className="widget-list-action text-nowrap text-white pb-1 pt-1 text-left">
                    Country wise scans
                    </h4>
                </div>
            </ModalHeader>
            <ModalBody>
                <div className="sparkline8-list shadow-reset">
                    <div className="sparkline8-graph table-responsive">
                        <DataTable
                            value={DatatablecountryWiseScanLits}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[10, 20, 30, 50]}
                            tableStyle={{ minWidth: '45rem' }}
                            totalRecords={DatatablecountryWiseScanLits ? DatatablecountryWiseScanLits?.length : 0}
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                            className="justify-content-end"
                            stripedRows
                            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
                            <Column
                                field="sr"
                                header="Sr #"
                                style={{
                                    width: '7%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 10px',
                                    textAlign: 'center',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="name"
                                header="Country"
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                    fontWeight: "600"

                                }}
                                body={countryBodyTemplate}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="totalScanCount"
                                header="Total Scans"
                                sortable
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="representative.name"
                                header="Actions"
                                style={{
                                    width: '2%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                body={buttonTemplate}
                            />
                        </DataTable>


                    </div>
                </div>

            </ModalBody>
        </Modal>
    );
};


export const Bestperformingvendors = ({ isOpen, toggleVendorsshowall, DatatableVendorWiseList, getVendorwisescanningDetail }) => {
    const buttonTemplate = (data) => (
        <>
            <div>
                <button
                    onClick={() => {
                        getVendorwisescanningDetail(data);
                    }}
                    className="btn btn-primary btn-xs ml-3 "
                >
                    Details
                </button >
            </div>
        </>
    );



    const productImageBodyTemplate = (rowData) => {

        let FullPath = `${Config.contentUrl + rowData.logoPath}`;
        return (
            <img
                src={FullPath}
                style={{ height: "50px" }}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = "../assets/img/noimage.jpg";
                }}
            ></img>

        );

    };
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggleVendorsshowall}
            className="modal-size"
        >
            <ModalHeader
                toggle={toggleVendorsshowall}
                className="modalheader "
            >
                <div className="widget-list-item">
                    <h4 className="widget-list-action text-nowrap text-white pb-1 pt-1 text-left">
                        Best performing vendors
                    </h4>
                </div>
            </ModalHeader>
            <ModalBody>
                <div className="sparkline8-list shadow-reset">
                    <div className="sparkline8-graph table-responsive">
                        <DataTable
                            value={DatatableVendorWiseList}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[10, 20, 30, 50]}
                            tableStyle={{ minWidth: '45rem' }}
                            totalRecords={DatatableVendorWiseList ? DatatableVendorWiseList?.length : 0}
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                            className="justify-content-end"
                            stripedRows
                            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
                            <Column
                                field="sr"
                                header="Sr #"
                                style={{
                                    width: '7%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 10px',
                                    textAlign: 'center',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="vendorName"
                                header="Vendor Name"
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                    fontWeight: "600"

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />

                            <Column
                                field="Image"
                                header="Logo"
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                    fontWeight: "600"

                                }}
                                body={productImageBodyTemplate}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="totalVendorScanCount"
                                header="Total Scans"
                                sortable
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="representative.name"
                                header="Actions"
                                style={{
                                    width: '2%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                body={buttonTemplate}
                            />
                        </DataTable>


                    </div>
                </div>

            </ModalBody>
        </Modal>
    );
};

//Personal reports

export const PersonalTimeWiseAnalysis = ({ isOpen, toggleLableTableclosed, articleTimeWiseScanListDetalis }) => {

    const productImageBodyTemplate = (rowData) => {

        let FullPath = `${Config.contentUrl + rowData.imagePath}`;
        return (
            <img
                src={FullPath}
                style={{ height: "50px" }}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = "../assets/img/noimage.jpg";
                }}
            ></img>

        );

    };
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggleLableTableclosed}
            className="modal-size"
        >
            <ModalHeader
                toggle={toggleLableTableclosed}
                className="modalheader "
            >
                <div className="widget-list-item">
                    <h4 className="widget-list-action text-nowrap text-white pb-1 pt-1 text-left">
                    Time Wise Analysis
                    </h4>
                </div>
            </ModalHeader>
            <ModalBody>
                <div className="sparkline8-list shadow-reset">
                    <div className="sparkline8-graph table-responsive">
                        <DataTable
                            value={articleTimeWiseScanListDetalis}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[10, 20, 30, 50]}
                            tableStyle={{ minWidth: '45rem' }}
                            totalRecords={articleTimeWiseScanListDetalis ? articleTimeWiseScanListDetalis?.length : 0}
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                            className="justify-content-end"
                            stripedRows
                            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
                            <Column
                                field="sr"
                                header="Sr #"
                                style={{
                                    width: '7%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 10px',
                                    textAlign: 'center',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="articleName"
                                header="Personal name"
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                    fontWeight: "600"

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />

                            <Column
                                field="Image"
                                header="Image"
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                    fontWeight: "600"

                                }}
                                body={productImageBodyTemplate}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="totalScanCount"
                                header="Total Scans"
                                sortable
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                        </DataTable>


                    </div>
                </div>

            </ModalBody>
        </Modal>
    );
};

export const PersonalCountrywisescans = ({ isOpen, togglecountryTableclosed, DatatablecountryWiseScanLits, toggleCountry }) => {

    const buttonTemplate = (data) => (
        <>
            <div>
                <button
                    onClick={() => {
                        toggleCountry(data);
                    }}
                    className="btn btn-primary btn-xs ml-3 "
                >
                    Details
                </button >
            </div>
        </>
    );

    const countryBodyTemplate = (rowData) => {
        let CountryId = countryList.find((x) => x.name === rowData.name);
        return (
            <div className="flex widget-list-media icon w-100" style={{ textAlign: 'center' }}>
                <img
                    src={`https://flagpedia.net/data/flags/normal/${CountryId?.code?.toLowerCase()}.png`}
                    className="flag-image-left"
                />
                <div className="widget-list-content  pb-1 pt-1 border-none d-inline-block">
                    <h5 className="widget-list-title">{rowData.name}</h5>


                </div>
            </div>

        );
    };
    return (
        <Modal
            isOpen={isOpen}
            toggle={togglecountryTableclosed}
            className="modal-size"
        >
            <ModalHeader
                toggle={togglecountryTableclosed}
                className="modalheader "
            >
                <div className="widget-list-item">
                    <h4 className="widget-list-action text-nowrap text-white pb-1 pt-1 text-left">
                    Country wise scans
                    </h4>
                </div>
            </ModalHeader>
            <ModalBody>
                <div className="sparkline8-list shadow-reset">
                    <div className="sparkline8-graph table-responsive">
                        <DataTable
                            value={DatatablecountryWiseScanLits}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[10, 20, 30, 50]}
                            tableStyle={{ minWidth: '45rem' }}
                            totalRecords={DatatablecountryWiseScanLits ? DatatablecountryWiseScanLits?.length : 0}
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                            className="justify-content-end"
                            stripedRows
                            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
                            <Column
                                field="sr"
                                header="Sr #"
                                style={{
                                    width: '7%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 10px',
                                    textAlign: 'center',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="name"
                                header="Country"
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                    fontWeight: "600"

                                }}
                                body={countryBodyTemplate}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="totalScanCount"
                                header="Total Scans"
                                sortable
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="representative.name"
                                header="Actions"
                                style={{
                                    width: '2%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                body={buttonTemplate}
                            />
                        </DataTable>


                    </div>
                </div>

            </ModalBody>
        </Modal>
    );
};


export const  PersonalBestScancategoryisall = ({ isOpen, toggleCetegoryTableclosed, DatatableCategoryListdata, togglecategory }) => {
    const buttonTemplate = (data) => (
        <>
            <div>
                <button
                    onClick={() => {
                        togglecategory(data);
                    }}
                    className="btn btn-primary btn-xs ml-3 "
                >
                    Details
                </button >
            </div>
        </>
    );
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggleCetegoryTableclosed}
            className="modal-size"
        >
            <ModalHeader
                toggle={toggleCetegoryTableclosed}
                className="modalheader "
            >
                <div className="widget-list-item">
                    <h4 className="widget-list-action text-nowrap text-white pb-1 pt-1 text-left">
                    Category wise scanning
                    </h4>
                </div>
            </ModalHeader>
            <ModalBody>



                <div className="sparkline8-list shadow-reset">
                    <div className="sparkline8-graph table-responsive">
                        <DataTable
                            value={DatatableCategoryListdata}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[10, 20, 30, 50]}
                            tableStyle={{ minWidth: '45rem' }}
                            totalRecords={DatatableCategoryListdata ? DatatableCategoryListdata?.length : 0}
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                            className="justify-content-end"
                            stripedRows
                            sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}>
                            <Column
                                field="sr"
                                header="Sr #"
                                style={{
                                    width: '7%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 10px',
                                    textAlign: 'center',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="categoryName"
                                header="Category"
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                    fontWeight: "600"

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="totalBestScanCount"
                                header="Total Scans"
                                sortable
                                style={{
                                    width: '25%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',

                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                bodyStyle={{ textAlign: 'center' }}
                            />
                            <Column
                                field="representative.name"
                                header="Actions"
                                style={{
                                    width: '2%',
                                    border: '1px solid #e4e7ea',
                                    padding: '25px 15px',
                                }}
                                headerStyle={{ background: '#f2f2f2' }}
                                body={buttonTemplate}
                            />
                        </DataTable>


                    </div>
                </div>

            </ModalBody>
        </Modal>
    );
};

